import React from 'react'
import { Formik, Form, Field, ErrorMessage } from "formik";


export default function FeedbackForm({openFeedBackForm,setOpenFeedBackform}) {
    const initialValues = {
        application: "",
        rating: "",
        fileFormat: "",
        improvement: "",
        comments: "",
    };


    // Handle submit function
    const handleSubmit = (values) => {
        console.log("Form values:", values);
    };
    return (
        <div>
            {openFeedBackForm &&
                <div className="fixed inset-0 z-50 flex items-center justify-center">
                    <div
                        className="absolute inset-0 bg-black bg-opacity-40"
                        onClick={() => setOpenFeedBackform(false)}
                    ></div>
                    <div className="relative bg-white rounded-xl shadow-lg w-full max-w-2xl p-6">
                        {/* Header */}
                        <div className="flex justify-between items-center border-b pb-3 mb-4">
                            <h2 className="text-lg text-[#283C50] font-semibold">
                                Feedback
                            </h2>
                            <button
                                onClick={() => setOpenFeedBackform(false)}
                                className="text-gray-400 hover:text-gray-600 text-xl"
                            >
                                ✕
                            </button>
                        </div>

                        {/* Formik Form */}
                        <Formik
                            initialValues={initialValues}
                            onSubmit={handleSubmit}
                        >
                            {({ values, setFieldValue }) => (
                                <Form className="max-h-[750px] overflow-y-auto pr-2 scrollbar-hide">

                                    {/* Subject */}
                                    <label className="text-md text-[#717576] font-normal">Select Application</label>
                                    <div className="relative">
                                        <Field
                                            as="select"
                                            name="application"
                                            className="w-full border py-2 px-4 text-md my-[9px] h-[60px] rounded-[10px] appearance-none pr-10 focus:outline-none focus-visible:outline-none"
                                        >
                                            <option value="">--Select--</option>
                                            <option value="Math Master">Math Master</option>
                                        </Field>

                                        {/* Custom dropdown arrow */}
                                        <svg
                                            width="20"
                                            height="11"
                                            viewBox="0 0 20 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                                        >
                                            <path d="M10 11L0 0L20 0L10 11Z" fill="black" />
                                        </svg>
                                    </div>

                                    <div className='mt-3'>
                                        <label className="text-md text-[#717576] font-normal">Rating</label>
                                        <div className='flex justify-between mt-2' role="group" aria-labelledby="my-radio-group">
                                            <label className='text-md text-[#717576] cursor-pointer'>
                                                <Field type="radio" name="rating" value="Average" className='mr-2' />
                                                Average
                                            </label>
                                            <label className='text-md text-[#717576] cursor-pointer'>
                                                <Field type="radio" name="rating" value="Good" className='mr-2' />
                                                Good
                                            </label>
                                            <label className='text-md text-[#717576] cursor-pointer'>
                                                <Field type="radio" name="rating" value="Very Good" className='mr-2' />
                                                Very Good
                                            </label>
                                            <label className='text-md text-[#717576] cursor-pointer'>
                                                <Field type="radio" name="rating" value="Excellent" className='mr-2' />
                                                Excellent
                                            </label>
                                        </div>
                                    </div>

                                    <div className='mt-3'>
                                        <label className="text-md text-[#717576] font-normal">File Format Selection</label>
                                        <div className='mt-2 p-6 flex border border-gray-100 rounded-[16px]'>
                                            <div className='w-64'>
                                                <div>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="fileFormat" value="Easy to use" className='mr-3' />
                                                        Easy to use
                                                    </label>
                                                </div>
                                                <div className='mt-2'>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="fileFormat" value="Helped me learn" className='mr-3' />
                                                        Helped me learn
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='w-64'>
                                                <div>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="fileFormat" value="Fun & engaging" className='mr-3' />
                                                        Fun & engaging
                                                    </label>
                                                </div>
                                                <div className='mt-2'>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="fileFormat" value="Clear instructions" className='mr-3' />
                                                        Clear instructions
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3'>
                                        <label className="text-md text-[#717576] font-normal">What could be improved?</label>
                                        <div className='mt-2 p-6 flex border border-gray-100 rounded-[16px]'>
                                            <div className='w-64'>
                                                <div>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="improvement" value="Too difficult" className='mr-3' />
                                                        Too difficult
                                                    </label>
                                                </div>
                                                <div className='mt-2'>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="improvement" value="Technical issues" className='mr-3' />
                                                        Technical issues
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='w-64'>
                                                <div>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="improvement" value="Too easy" className='mr-3' />
                                                        Too easy
                                                    </label>
                                                </div>
                                                <div className='mt-2'>
                                                    <label className='text-md text-[#717576] cursor-pointer'>
                                                        <Field type="radio" name="improvement" value="More examples needed" className='mr-3' />
                                                        More examples needed
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-3'>
                                        <label className="text-md text-[#717576] font-normal">
                                            Additional Comment (Optional)
                                        </label>
                                        <Field
                                            as="textarea"
                                            name="comments"
                                            placeholder="Share Your Thought and suggestions here"
                                            className="w-full border p-2 text-md my-[9px] bg-[#7175760F] rounded-[10px]"
                                            rows={4}
                                        />
                                    </div>

                                    {/* Footer */}
                                    <div className="flex justify-between gap-3 pt-4">
                                        <button
                                            type="button"
                                            onClick={() => setOpenFeedBackform(false)}
                                            className="px-4 py-4 w-full rounded-[10px] border border-brandBlue text-brandBlue bg-transparent hover:bg-brandBlue hover:text-white transition"
                                        >
                                            Cancel
                                        </button>

                                        <button
                                            type="submit"
                                            className="px-4 py-4 w-full rounded-[10px] bg-brandBlue text-white hover:bg-primary-700 transition"
                                        >
                                            Submit Feedback
                                        </button>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>

                </div>
            }
        </div>
    )
}
